<template>
    <zh-table-page
      ref="tableRef"
      v-bind="{
      title: '部门管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      initialForm,
      ...table,
      ...dialog,
    }"
    @action="handleAction"
  >
  </zh-table-page>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("只为能正整数"));
      }
    };
    const state = reactive({
      search: [
        {
          component: "zh-tree-select",
          placeholder: "请选择部门",
          value: "organizationCode",
          url: "getOrganizationalGetOrganizationalTreeSelect",
          field: {
            organizationCode: "value",
            organizationName: "label",
          },
          filterable: true,
        },
      ],
      api: {
        list: "getOrganizationalGetOrganizationalTreeSelect",
        delete: "deleteOrganizationalDelete",
        deleteAll: "",
        add: "postOrganizationalSave",
        edit: "postOrganizationalUpdate",
        detail: "getOrganizational",
        path: "", //详情页面路由
      },
      table: {
        columns: [
          {
            prop: "organizationName",
            label: "部门名称",
            align: "left",
          },
          {
            prop: "organizationTypeStr",
            label: "部门类型",
          },
          {
            prop: "showOrder",
            label: "排序",
          },
          {
            label: "状态",
            prop: "state",
            scopeComponent: "common-switch",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
        ],
        operations: [
          {
            label: "新增",
          },
          {
            label: "编辑",
          },

          {
            label: "删除",
            type: "danger",
            disabledFun: (row) => {
              return row.roleCode == 1;
            },
          },
        ],
        rowKey: "organizationCode",
      },
      dialog: {
        dialogForm: [
          {
            component: "zh-tree-select",
            label: "上级部门",
            placeholder: "请选择上级部门",
            value: "parentCode",
            url: "getOrganizationalGetOrganizationalTreeSelect",
            field: {
              organizationCode: "value",
              organizationName: "label",
            },
            showCondition: (form) => {
              return form.organizationCode !== "1";
            },
          },
          {
            label: "部门名称",
            placeholder: "请输入部门名称",
            value: "organizationName",
          },
          {
            component: "zh-tree-select",
            label: "部门类型",
            placeholder: "请选择部门类型",
            value: "organizationType",
            url: "postDictDataList",
            params: {
              dictType: "center_org_type",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
          },
          {
            component: "zh-select",
            label: "部门状态",
            placeholder: "请选择部门状态",
            value: "state",
            url: "postDictDataList",
            params: {
              dictType: "center_use_state",
            },
            field: {
              dictValue: "value",
              dictLabel: "label",
            },
          },
          {
            component: "el-input-number",
            label: "显示排序",
            placeholder: "请输入显示排序",
            value: "showOrder",
            defaultValue: 1,
            min: 1,
          },
          {
            component: "zh-select",
            label: "负责人",
            placeholder: "请选择负责人",
            value: "principal",
            url: "postUserList",
            field: {
              userCode: "value",
              nikeName: "label",
            },
          },
          {
            component: "zh-select",
            label: "关联岗位",
            placeholder: "请选择关联岗位",
            value: "postCode",
            url: "postPostList",
            params: {
              state: 0,
            },
            field: {
              postCode: "value",
              postName: "label",
            },
            multiple: true,
            filterable: true,
          },
          {
            label: "联系电话",
            placeholder: "请输入联系电话",
            value: "phone",
          },
          {
            label: "邮箱",
            placeholder: "请输入邮箱",
            value: "email",
          },
          // {
          //   component: "zh-select",
          //   label: "部门类型",
          //   placeholder: "请选择部门类型",
          //   value: "deptType",
          //   options: [
          //     {
          //       value: "1",
          //       label: "集团",
          //     },
          //     {
          //       value: "2",
          //       label: "片区",
          //     },
          //     {
          //       value: "3",
          //       label: "公司",
          //     },
          //     {
          //       value: "4",
          //       label: "厂站",
          //     },
          //     {
          //       value: "5",
          //       label: "部门",
          //     },
          //   ],
          // },
        ],
        dialogRules: {
          parentCode: [
            { required: true, message: "上级部门不能为空", trigger: "change" },
          ],
          organizationName: [
            { required: true, message: "部门名称不能为空", trigger: "blur" },
          ],
          state: [
            { required: true, message: "部门状态不能为空", trigger: "change" },
          ],
          organizationType: [
            { required: true, message: "部门类型不能为空", trigger: "change" },
          ],
          deptCode: [
            { required: true, message: "部门编码不能为空", trigger: "blur" },
          ],
          showOrder: [
            { required: true, message: "显示排序不能为空", trigger: "blur" },
            { validator: blurText, trigger: "change" },
          ],
          deptType: [
            { required: true, message: "部门类型", trigger: "change" },
          ],
          email: [
            {
              type: "email",
              message: "'请输入正确的邮箱地址",
              trigger: ["blur", "change"],
            },
          ],
          phone: [
            {
              pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
              message: "请输入正确的手机号码",
              trigger: "blur",
            },
          ],
        },
      },
    });
    onMounted(() => {});
    const parsePostCodes = (postCode) => {
      if (Array.isArray(postCode)) {
        return postCode
          .map((item) => String(item).trim())
          .filter((item) => item);
      }
      if (typeof postCode === "string") {
        return postCode
          .split(/,|，/)
          .map((item) => item.trim())
          .filter((item) => item);
      }
      return [];
    };
    const stringifyPostCodes = (postCode) => {
      const list = parsePostCodes(postCode);
      return list.length > 0 ? list.join(",") : null;
    };
    const afterGetDetail = (data) => {
      return {
        ...data,
        state: data.state?.value,
        // 详情接口返回逗号字符串时，转成数组给多选下拉回显
        postCode: parsePostCodes(data.postCode),
      };
    };
    const beforeSave = (form) => {
      return {
        ...form,
        // 提交时统一转回逗号分隔字符串
        postCode: stringifyPostCodes(form.postCode),
      };
    };
    const handleAction = (item, type) => {
      if (type === "scope") {
        proxy
          .$confirm("是否修改部门状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api.getOrganizational(item.organizationCode).then((res) => {
              proxy.$api
                .postOrganizationalUpdate({
                  ...res.data,
                  state: res.data.state.value == 1 ? 0 : 1,
                })
                .then((res) => {
                  tableRef.value.getData();
                  proxy.$message.success("操作成功");
                });
            });
          })
          .catch(() => {
            tableRef.value.getData();
          });
      }
    };
    const initialForm = (data) => {
      if (data) {
        return {
          parentCode: data?.organizationCode ?? "",
          showOrder: 1,
        };
      }
      return {};
    };
    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
      handleAction,
      initialForm,
    };
  },
});
</script>
